var _circle, _rect, _rect2, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_89)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.2773,
    y: 47.7236,
    width: 9.84797,
    height: 4.14651,
    transform: "rotate(45.1402 50.2773 47.7236)",
    fill: "#393184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2769,
    y: 52.335,
    width: 23.3964,
    height: 10.358,
    rx: 3,
    transform: "rotate(43.7705 59.2769 52.335)",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_89)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.0853,
    cy: 41.0853,
    r: 17.0853,
    fill: "url(#paint1_linear_1062_89)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.0853,
    cy: 41.0853,
    r: 17.0853,
    stroke: "url(#paint2_linear_1062_89)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3871 28.3992C47.5582 28.7378 49.8476 29.8753 51.4554 31.4142C53.6184 33.4847 54.8621 36.1616 55.0402 39.1297C55.0876 39.9223 55.0721 40.0806 54.9196 40.358C54.6646 40.8214 54.2314 41.0859 53.7278 41.0854C52.9358 41.0848 52.3574 40.5024 52.3568 39.7049C52.3557 38.4013 51.8859 36.6639 51.2157 35.4855C50.1458 33.6046 48.3785 32.1286 46.3879 31.4534C45.6992 31.2199 44.4102 30.987 43.8058 30.987C43.2164 30.987 42.8095 30.8052 42.5054 30.4057C41.9982 29.7395 42.2795 28.7103 43.0578 28.3845C43.4299 28.2287 44.3304 28.2343 45.3871 28.3992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_89",
    x: 21.85,
    y: 21.85,
    width: 38.4704,
    height: 38.4709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_89"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_89",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_89",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_89",
    x1: 27.6566,
    y1: 27.1526,
    x2: 64.5392,
    y2: 46.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_89",
    x1: 43.9328,
    y1: 29.6951,
    x2: 56.7468,
    y2: 59.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.87befafc2650f9a113c67434e82c8df5.svg";
export { ForwardRef as ReactComponent };